import React from 'react';
import PropTypes from 'prop-types';
import CharacterCounterNumWrapper from './styles/CharacterCounterNumWrapper';
import CharacterCounterWrapper from './styles/CharacterCounterWrapper';


const CharacterCounter = React.memo(function CharacterCounter(props) {

  const {
    characterNum,
    maxCharacters,
    thisStyles,
  } = props;


  return (
    <CharacterCounterWrapper thisStyles={thisStyles}>
      {`Max ${maxCharacters} characters. Currently:`}
      <CharacterCounterNumWrapper
        characterNum={characterNum ? characterNum : 0}
        maxCharacters={maxCharacters ? maxCharacters : 1}
      >
        {characterNum ? characterNum : 0}
      </CharacterCounterNumWrapper>
    </CharacterCounterWrapper>
  );

});

CharacterCounter.propTypes = {
  characterNum: PropTypes.number,
  maxCharacters: PropTypes.number
};

export default CharacterCounter;
